import { create } from 'zustand';
import { devtools } from 'zustand/middleware';
import { GroupObj, iTreeData } from '../groups/interfaces/types';
interface GroupStoreState {
  // State
  selectedDataGroup: GroupObj | null;
  dataGroups: GroupObj[];
  checkedKeysGroupDeviceManager: string[];
  checkedKeysManagesGroup: string[];
  treeDataDeviceManagerGroup: iTreeData[];
  tabKeyGroup: string;

  // UI State
  isEditingGroup: boolean;
  isEditNewGroup: boolean;
  isEditingModeGroup: boolean;
  isModalOpenGroup: boolean;
  isLoadingSubmitGroup: boolean;
  isLoadingDataGroup: boolean;
  isDataEditedGroup: boolean;
  isEditedTreeDeviceManager: boolean;
}

interface GroupStoreActions {
  setIsEditingGroup: (value: boolean) => void;
  setIsEditNewGroup: (value: boolean) => void;
  setDataGroups: (data: GroupObj[]) => void;
  setIsEditingModeGroup: (value: boolean) => void;
  setIsModalOpenGroup: (value: boolean) => void;
  setCheckedKeysGroupDeviceManager: (keys: string[]) => void;
  setTreeDataDeviceManagerGroup: (data: iTreeData[]) => void;
  setIsLoadingSubmitGroup: (value: boolean) => void;
  setIsLoadingDataGroup: (value: boolean) => void;
  setCheckedKeysManagesGroup: (keys: string[]) => void;
  setIsDataEditedGroup: (value: boolean) => void;
  setTabKeyGroup: (key: string) => void;
  setIsEditedTreeDeviceManager: (value: boolean) => void;
  setSelectedDataGroup: (values: GroupObj | Partial<GroupObj> | null) => void;
}

export const GROUPS_INITIAL_STATE: GroupStoreState = {
  // State
  selectedDataGroup: null,
  dataGroups: [],
  checkedKeysGroupDeviceManager: [],
  checkedKeysManagesGroup: [],
  treeDataDeviceManagerGroup: [],
  tabKeyGroup: '1',

  // UI State
  isEditingGroup: false,
  isEditNewGroup: false,
  isEditingModeGroup: false,
  isModalOpenGroup: false,
  isLoadingSubmitGroup: false,
  isLoadingDataGroup: false,
  isDataEditedGroup: false,
  isEditedTreeDeviceManager: false,
};

export const useGroupsStore = create<GroupStoreState & GroupStoreActions>()(
  devtools((set) => ({
    // State
    ...GROUPS_INITIAL_STATE,
    // Actions
    setIsEditingGroup: (value) => set({ isEditingGroup: value }),
    setIsEditNewGroup: (value) => set({ isEditNewGroup: value }),
    setDataGroups: (data) => set({ dataGroups: data }),
    setIsEditingModeGroup: (value) => set({ isEditingModeGroup: value }),
    setIsModalOpenGroup: (value) => set({ isModalOpenGroup: value }),
    setCheckedKeysGroupDeviceManager: (keys) => set({ checkedKeysGroupDeviceManager: keys }),
    setTreeDataDeviceManagerGroup: (data) => set({ treeDataDeviceManagerGroup: data }),
    setIsLoadingSubmitGroup: (value) => set({ isLoadingSubmitGroup: value }),
    setIsLoadingDataGroup: (value) => set({ isLoadingDataGroup: value }),
    setCheckedKeysManagesGroup: (keys) => set({ checkedKeysManagesGroup: keys }),
    setIsDataEditedGroup: (value) => set({ isDataEditedGroup: value }),
    setTabKeyGroup: (key) => set({ tabKeyGroup: key }),
    setIsEditedTreeDeviceManager: (value) => set({ isEditedTreeDeviceManager: value }),
    setSelectedDataGroup: (values) => {
      if (values === null) {
        set({ selectedDataGroup: null });
      } else {
        set((state) => ({
          selectedDataGroup: state.selectedDataGroup
            ? ({ ...state.selectedDataGroup, ...values })
            : (values as GroupObj),
        }));
      }
    },
  }))
);
